import { ElementRef, OnInit } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
var TooltipWhenTruncatedDirective = /** @class */ (function () {
    function TooltipWhenTruncatedDirective(elementRef, matTooltip) {
        this.elementRef = elementRef;
        this.matTooltip = matTooltip;
        this.tooltipText = '';
    }
    TooltipWhenTruncatedDirective.prototype.ngOnInit = function () {
        var _this = this;
        this.checkIfTextIsTruncated();
        this.elementRef.nativeElement.addEventListener('mouseenter', function () {
            _this.checkIfTextIsTruncated();
        });
    };
    TooltipWhenTruncatedDirective.prototype.checkIfTextIsTruncated = function () {
        var _this = this;
        setTimeout(function () {
            var element = _this.elementRef.nativeElement;
            if (element.scrollWidth > element.clientWidth) {
                _this.matTooltip.message = _this.tooltipText || element.textContent;
            }
            else {
                _this.matTooltip.hide();
            }
        });
    };
    return TooltipWhenTruncatedDirective;
}());
export { TooltipWhenTruncatedDirective };
